import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const REGED_SUPPORTED_FORMATS_QUERY_KEY = 'regEdSupportedFormats';

/**
 * Formats are AdTrax EXT IDs. The service errors when the account has no RegEd integration, so
 * callers gate with `enabled`.
 */
export const useRegEdSupportedFormatsQuery = ({
	enabled = true,
	impersonationContext,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryKey: [REGED_SUPPORTED_FORMATS_QUERY_KEY, impersonationContext?.account?.id],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'compliance/regEd/supportedFormats',
				}),
				'GET'
			),
		meta: {
			toastErrorMessage: 'Failed to load the compliance submission formats.',
		},
	});
};
